import { generateConf, setAuth } from '@topconagriculture/frontend-utils';
import WeatherServiceFactory from './weather/weather.api';
import WidgetServiceFactory from './widget/widget.api';
import FieldServiceFactory from './fields/field.api';
import GeocodingServiceFactory from './geocoding/geocoding.api';
import InventoryServiceFactory from './inventory/inventory.api';
import FarmsServiceFactory from './farms/farms.api';
import LoadsServiceFactory from './deviation/loads.api';
import DeliveriesServiceFactory from './deviation/deliveries.api';
export const ApiManager = (params) => {
    const { HTTPBaseURL, HTTPInventory, HTTPFields, googleMapApiKey } = params;
    const HTTP = generateConf({ baseURL: HTTPBaseURL });
    const inventoryAPI = generateConf({ baseURL: HTTPInventory });
    const fieldsAPI = generateConf({ baseURL: HTTPFields });
    return {
        setAuthToken(tokenNew, tenantId) {
            setAuth(tenantId, tokenNew, HTTP, fieldsAPI, inventoryAPI);
        },
        weather: WeatherServiceFactory({ HTTPBase: HTTP }),
        widget: WidgetServiceFactory({ HTTPBase: HTTP }),
        field: FieldServiceFactory({ HTTPFields: fieldsAPI }),
        geocoding: GeocodingServiceFactory(googleMapApiKey),
        inventory: InventoryServiceFactory({ HTTPInventory: inventoryAPI }),
        farms: FarmsServiceFactory({ HTTPFarms: inventoryAPI }),
        loads: LoadsServiceFactory({ HTTPDeviations: inventoryAPI }),
        deliveries: DeliveriesServiceFactory({ HTTPDeviations: inventoryAPI }),
    };
};
//# sourceMappingURL=api.js.map